import {
  Button,
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";

import "./index.css";

const useStyles = makeStyles({
  root: {
    minWidth: 255,
    backgroundImage:
      "url(data:image/png;base64,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)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "50%",
    boxShadow: "0 18px 18px rgb(25 31 79 / 13%)",
    borderRadius: "8px",
  },
  cardContent: {
    display: "flex",
    marginLeft: "5px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  downloadButton: {
    background: "#e83a1f",
    color: "white",
    fontFamily: `"Poppins", sans-serif`,
    fontStyle: "normal",
    fontSize: 12,
    "&:hover": {
      background: "#e83a1f",
      filter: "brightness(1.2)",
    },
  },
});

export default function DownloadItems(props) {
  const classes = useStyles();
  const { downloadData } = props;

  let bulkPrintout = downloadData.filter((data) => {
    return data.is_bulk;
  });

  let coachPrintouts = downloadData.filter((data) => {
    return data.title === "coach_printout" && !data.is_bulk;
  });

  let athletePrintouts = downloadData.filter((data) => {
    return data.title === "athlete_printout" && !data.is_bulk;
  });

  let combinedWeeklyData = [];

  coachPrintouts.forEach((item) => {
    const week = parseInt(item.week);
    if (!combinedWeeklyData[week]) {
      combinedWeeklyData[week] = {
        coach: [item],
      };
    } else {
      combinedWeeklyData[week].coach.push(item);
    }
  });

  athletePrintouts.forEach((item) => {
    const week = parseInt(item.week);
    if (!combinedWeeklyData[week]) {
      combinedWeeklyData[week] = {
        athlete: [item],
      };
    } else if (!combinedWeeklyData[week].athlete) {
      combinedWeeklyData[week]["athlete"] = [item];
    } else {
      combinedWeeklyData[week].athlete.push(item);
    }
  });

  return (
    <Grid container style={{ marginTop: 34 }}>
      {combinedWeeklyData.map((data, index) => {
        const title = `Week ${index}`;
        return (
          <Grid container style={{ marginBottom: 62 }} spacing={3}>
            <Grid item xs={12}>
              <div className="groupOfDownloadsLabel" key={index}>
                {title}
              </div>
            </Grid>
            {data.coach
              ? data.coach.map((item) => (
                  <Grid item xs={12} sm={12} md={12} lg={4} key={item.file}>
                    <Card className={classes.root}>
                      <CardContent className={classes.cardContent}>
                        <div className="downloadItemTitle">Coach Printout</div>
                        <a
                          href={item.file}
                          target="_blank"
                          style={{ color: "transparent" }}
                        >
                          <Button className={classes.downloadButton}>
                            Download
                          </Button>
                        </a>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              : null}
            {data.athlete
              ? data.athlete.map((item) => (
                  <Grid item xs={12} sm={12} md={12} lg={4}>
                    <Card className={classes.root}>
                      <CardContent className={classes.cardContent}>
                        <div className="downloadItemTitle">
                          Athlete Printout
                        </div>
                        <a
                          href={item.file}
                          target="_blank"
                          style={{ color: "transparent" }}
                        >
                          <Button className={classes.downloadButton}>
                            Download
                          </Button>
                        </a>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              : null}
          </Grid>
        );
      })}
    </Grid>
  );
}
